import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayName'
})
export class DisplayNamePipe implements PipeTransform {

  transform(sender: any, fallback?: any): string {
    let userName = ''
    if (sender) {
      userName = sender.display_name || sender.name || '';
    }  else if (fallback) {
      userName = fallback;
    }
    return userName ? contentSplice(userName, 4) : '-';
  }
}

function contentSplice(name: string, position: number = 0) {
  return name.length >= 15 ? `${name.slice(0, position)}...${name.slice(name.length - position)}` : name
}
